<template>
  <div class="main print-no-padding punch">
    <h2 class="is-print-hide title-area">
      <span class="main-title">打卡管理</span>
    </h2>
    <el-card class="box-card">
      <search-bar :search-param="searchParams" @search="search" />
      <punch-table :data="punchList" />
      <pagination
        @handlePage="handlePage"
        v-if="punchList && punchList.length"
        :total="total"
        :current-page="pageNo"
        :page-size="pageSize"
      />
    </el-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import searchBar from './components/searchBar';
import punchTable from './components/punchTable';
import pagination from './components/pagination';

export default {
  name: 'punch',
  components: {
    searchBar,
    punchTable,
    pagination
  },
  computed: {
    ...mapState('punch', {
      searchParams: state => state.searchParams,
      pageNo: state => state.pageNo,
      pageSize: state => state.pageSize,
      total: state => state.total,
      punchList: state => state.punchList
    })
  },
  created() {
    this.getList();
  },
  methods: {
    ...mapActions('punch', ['fetchPunchList']),
    getList(params) {
      params = this.$checkPower('b') ? { ...params, userId: this.$store.getters.ucUserId } : params;
      this.fetchPunchList(params);
    },
    search(params) {
      this.getList({ ...params, page: 1 });
    },
    handlePage(pageNo) {
      this.fetchPunchList({ ...this.searchParams, page: pageNo });
    }
  }
};
</script>

<style lang="scss" scoped></style>
